const messages = {
  title: "O BS Plus",
  description: "Opis strani",
};

export default {
  messages,
};
